import { render, staticRenderFns } from "./SectionApva.vue?vue&type=template&id=6557bd04&"
import script from "./SectionApva.vue?vue&type=script&lang=js&"
export * from "./SectionApva.vue?vue&type=script&lang=js&"
import style0 from "./SectionApva.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports